// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_backgroundHeader__nQrzW {
  background-color: #ffffff;
  margin-left: 40px !important;
  margin-right: 40px !important;
  margin-bottom: 25px !important;
  border-radius: 6px 6px 0 0;
  padding-bottom: 10px;
}

.styles_tituloContainer__X\\+zWa {
  display: flex !important;
  align-items: center !important;
  margin-left: 8px !important;
  margin-top: 12px;
}

.styles_titulo__Pw65S {
  font-size: 29px !important;
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
  margin-top: 0px;
  margin-bottom: 0px;
}

.styles_containerAutocomplete__LIu5x {
  padding-right: 12px;
}

.styles_iconeTitulo__Z83Yw {
  font-size: 50px !important;
  color: #0f2047 !important;
  margin-left: 8px !important;
  margin-top: -3px !important;
}

.styles_txtBuscaTabela__7TUwl {
  margin-top: 16px !important;
  margin-left: 16px !important;
}

.styles_iconeBusca__Qx\\+fC {
  color: #18316e !important;
  font-size: 28px !important;
  margin-top: 16px !important;
  margin-right: -12px !important;
}

.styles_botaoNovo__0HztB {
  width: 100% !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  font-size: 16px !important;
  margin-top: 12px !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  text-transform: capitalize !important;
  height: 36px !important;
}

.styles_botaoNovo__0HztB:disabled {
  background-color: #798eb9 !important;
}

.styles_botaoNovo__0HztB:hover {
  transform: scale(0.95) !important;
}

.styles_linhaTitulo__Au\\+Mt {
  border-bottom: 0.2rem solid #0f2047 !important;
  margin-left: 66px !important;
  margin-bottom: 0;
  width: 80px !important;
  padding-top: 8px !important;
}

.styles_campoBusca__PePz1 {
  display: flex;
  flex-direction: row;
  padding-right: 8px;
}

.styles_automplete__Center__tPLJU {
  margin-top: 1px !important;
}

.styles_buttonPadding__1NFqu {
  padding-left: 8px;
  padding-right: 8px;
}

.styles_yearMonth__uWIPU {
  padding-right: 8px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/CRUDPageHeader/styles.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8CAA8C;EAC9C,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".backgroundHeader {\n  background-color: #ffffff;\n  margin-left: 40px !important;\n  margin-right: 40px !important;\n  margin-bottom: 25px !important;\n  border-radius: 6px 6px 0 0;\n  padding-bottom: 10px;\n}\n\n.tituloContainer {\n  display: flex !important;\n  align-items: center !important;\n  margin-left: 8px !important;\n  margin-top: 12px;\n}\n\n.titulo {\n  font-size: 29px !important;\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n.containerAutocomplete {\n  padding-right: 12px;\n}\n\n.iconeTitulo {\n  font-size: 50px !important;\n  color: #0f2047 !important;\n  margin-left: 8px !important;\n  margin-top: -3px !important;\n}\n\n.txtBuscaTabela {\n  margin-top: 16px !important;\n  margin-left: 16px !important;\n}\n\n.iconeBusca {\n  color: #18316e !important;\n  font-size: 28px !important;\n  margin-top: 16px !important;\n  margin-right: -12px !important;\n}\n\n.botaoNovo {\n  width: 100% !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  font-size: 16px !important;\n  margin-top: 12px !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  text-transform: capitalize !important;\n  height: 36px !important;\n}\n\n.botaoNovo:disabled {\n  background-color: #798eb9 !important;\n}\n\n.botaoNovo:hover {\n  transform: scale(0.95) !important;\n}\n\n.linhaTitulo {\n  border-bottom: 0.2rem solid #0f2047 !important;\n  margin-left: 66px !important;\n  margin-bottom: 0;\n  width: 80px !important;\n  padding-top: 8px !important;\n}\n\n.campoBusca {\n  display: flex;\n  flex-direction: row;\n  padding-right: 8px;\n}\n\n.automplete__Center {\n  margin-top: 1px !important;\n}\n\n.buttonPadding {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.yearMonth {\n  padding-right: 8px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backgroundHeader": `styles_backgroundHeader__nQrzW`,
	"tituloContainer": `styles_tituloContainer__X+zWa`,
	"titulo": `styles_titulo__Pw65S`,
	"containerAutocomplete": `styles_containerAutocomplete__LIu5x`,
	"iconeTitulo": `styles_iconeTitulo__Z83Yw`,
	"txtBuscaTabela": `styles_txtBuscaTabela__7TUwl`,
	"iconeBusca": `styles_iconeBusca__Qx+fC`,
	"botaoNovo": `styles_botaoNovo__0HztB`,
	"linhaTitulo": `styles_linhaTitulo__Au+Mt`,
	"campoBusca": `styles_campoBusca__PePz1`,
	"automplete__Center": `styles_automplete__Center__tPLJU`,
	"buttonPadding": `styles_buttonPadding__1NFqu`,
	"yearMonth": `styles_yearMonth__uWIPU`
};
export default ___CSS_LOADER_EXPORT___;
